export default __webpack_public_path__ + "static/media/eleven_.3b8bfc6b.jpeg";